import styled from 'styled-components';

export const Container = styled.p`
  font-size: 14px;
  color: #ff5b00;
  align-self: flex-end;
  margin-bottom: 1rem !important;
  padding-right: 10px;
`;
